import { createSelector } from 'reselect';
import { requestStatusMessageSelector, requestStatusSelector, usersListSelector } from './selectors';

/**
 * Memoized selector that aggregates users list, request status, and request status message
 * for use on the users page.
 *
 * Combines the users list, the current request status, and the request status message
 * into a single object for convenient access in UI components.
 *
 * @function
 * @returns {Object} An object containing:
 *   @property {Array|undefined} usersList - The list of users.
 *   @property {string|undefined} requestStatus - The status of the current user-related request.
 *   @property {string|undefined} requestStatusMessage - The message associated with the current request status.
 *
 * @example
 * const { usersList, requestStatus, requestStatusMessage } = useSelector(usersPageSelector);
 */
export const usersPageSelector = createSelector(
    [usersListSelector, requestStatusSelector, requestStatusMessageSelector],
    (usersList, requestStatus, requestStatusMessage) => ({
        usersList,
        requestStatus,
        requestStatusMessage,
    }),
);
